document.addEventListener("DOMContentLoaded", function(_event) {
  var tiles = document.querySelectorAll('.tile-container');

  if (tiles.length > 0) {
    tiles.forEach((tile) => {
      const dotLottiePlayer = tile.querySelector('dotlottie-player');

      if (dotLottiePlayer) {
        tile.addEventListener('mouseenter', (_e) => {
          try {
            dotLottiePlayer.play();
          } catch (e) {
            console.log(`${e} - dotLottiePlayer.play() error`)
          }
        });
        tile.addEventListener('mouseleave', (_e) => {
          try {
            dotLottiePlayer.pause();
          } catch (e) {
            console.log(`${e} - dotLottiePlayer.pause() error`)
          }
        });
      };
    });
  }
});
